
    import { makeI18n } from '@/services/i18n';
    import baseTranslation from "/app/src/components/email-verification/assets/common.lang.json"
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/modules/auth/pages/revert/revert-form.vue', {"email.text":{"ru_RU":"Вы сможете снова использовать почту '<strong>'{ email }'</strong>' для входа в ваш аккаунт","en_US":"You will be able to use email '<strong>'{ email }'</strong>' to log into your account again"},"button":{"ru_RU":"Восстановить почту","en_US":"Recover email"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/modules/auth/pages/revert/revert-form.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  